import React from "react";

const img2Url = "d2bv7sklk9z912.cloudfront.net"
const aFilesUrl = "d2o3vzu0igoa2n.cloudfront.net"

const cloudfrontConversion = (string) => {
    // convert all urls to cloudfront urls
    // replace all instances of img2.storyblok.com with d2bv7sklk9z912.cloudfront.net
    // replace all instances of a.storyblok.com with d2o3vzu0igoa2n.cloudfront.net

    if (string == null || string == ""){
        return string
    }

    string = string.replace(/img2.storyblok.com/g, img2Url)

    string = string.replace(/a.storyblok.com/g, aFilesUrl)

    return string

}

export default cloudfrontConversion